/**
 * Users ROUTES
 */
const routes = [
  //Users
  {
    path: '/User/Filter',
    name: 'UserFilterViewComponent',
    component: 'User/UserFilterViewComponent'
  },
  {
    path: '/User/Editor/:Id?',
    name: 'UserEditorViewComponent',
    component: 'User/UserEditorViewComponent',
    props: true
  }
];

export default routes;
